export const cobber_memory = [
  {
    "Address": "6E00",
    "Function": "accel_threshold;",
    "Notes": "Accelerometer wake threshold"
  },
  {
    "Address": "6E01",
    "Function": "min_time_before_sleep;",
    "Notes": "// Minimum time before sleep"
  },
  {
    "Address": "6E02",
    "Function": "min_time_before_wake;",
    "Notes": "// Minimum time before wake"
  },
  {
    "Address": "6E03",
    "Function": "n_modes;",
    "Notes": "Number of modes"
  },
  {
    "Address": "6E04",
    "Function": "n_interrupts",
    "Notes": "Number of interrupts required per seconds to wake"
  },
  {
    "Address": "6E05",
    "Function": "sleep_threshold",
    "Notes": "Accelerometer sleep threshold"
  },
  {
    "Address": "6E06",
    "Function": "wake_interrupt_duration",
    "Notes": "Sets the duration for which the generic interrupt motion conditions must be true before INT1 is set (2/50 = 0.04seconds)"
  },
  {
    "Address": "6E07",
    "Function": "sleep_interrupt_duration",
    "Notes": "Sets the duration for which the generic interrupt motion conditions must be true before INT1 is set (0/50 = 0.0seconds)"
  },
  {
    "Address": "6E08",
    "Function": "",
    "Notes": ""
  },
  {
    "Address": "6E09",
    "Function": "X Short Factor (EMA)   ///MODE 1",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E0A",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E0B",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E0C",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E0D",
    "Function": "X Number of Patterns",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E0E",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E0F",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E10",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E11",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E12",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E13",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E14",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E15",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E16",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E17",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E18",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E19",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E1A",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E1B",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E1C",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E1D",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E1E",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E1F",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E20",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E21",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E22",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E23",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E24",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E25",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 1"
  },
  {
    "Address": "6E26",
    "Function": "X Short Factor (EMA)   ///MODE 2",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E27",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E28",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E29",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E2A",
    "Function": "X Number of Patterns",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E2B",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E2C",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E2D",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E2E",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E2F",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E30",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E31",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E32",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E33",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E34",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E35",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E36",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E37",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E38",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E39",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E3A",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E3B",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E3C",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E3D",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E3E",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E3F",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E40",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E41",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E42",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 2"
  },
  {
    "Address": "6E43",
    "Function": "X Short Factor (EMA)   ///MODE 3",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E44",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E45",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E46",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E47",
    "Function": "X Number of Patterns",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E48",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E49",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E4A",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E4B",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E4C",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E4D",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E4E",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E4F",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E50",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E51",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E52",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E53",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E54",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E55",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E56",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E57",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E58",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E59",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E5A",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E5B",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E5C",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E5D",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E5E",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E5F",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 3"
  },
  {
    "Address": "6E60",
    "Function": "X Short Factor (EMA)   ///MODE 4",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E61",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E62",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E63",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E64",
    "Function": "X Number of Patterns",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E65",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E66",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E67",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E68",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E69",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E6A",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E6B",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E6C",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E6D",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E6E",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E6F",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E70",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E71",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E72",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E73",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E74",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E75",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E76",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E77",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E78",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E79",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E7A",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E7B",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E7C",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 4"
  },
  {
    "Address": "6E7D",
    "Function": "X Short Factor (EMA)   ///MODE 5",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E7E",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E7F",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E80",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E81",
    "Function": "X Number of Patterns",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E82",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E83",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E84",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E85",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E86",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E87",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E88",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E89",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E8A",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E8B",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E8C",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E8D",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E8E",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E8F",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E90",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E91",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E92",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E93",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E94",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E95",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E96",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E97",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E98",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E99",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 5"
  },
  {
    "Address": "6E9A",
    "Function": "X Short Factor (EMA)   ///MODE 6",
    "Notes": "MODE 6"
  },
  {
    "Address": "6E9B",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 6"
  },
  {
    "Address": "6E9C",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 6"
  },
  {
    "Address": "6E9D",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 6"
  },
  {
    "Address": "6E9E",
    "Function": "X Number of Patterns",
    "Notes": "MODE 6"
  },
  {
    "Address": "6E9F",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA0",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA1",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA2",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA3",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA4",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA5",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA6",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA7",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA8",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EA9",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EAA",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EAB",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EAC",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EAD",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EAE",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EAF",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB0",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB1",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB2",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB3",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB4",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB5",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB6",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 6"
  },
  {
    "Address": "6EB7",
    "Function": "X Short Factor (EMA)   ///MODE 7",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EB8",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EB9",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EBA",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EBB",
    "Function": "X Number of Patterns",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EBC",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EBD",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EBE",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EBF",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC0",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC1",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC2",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC3",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC4",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC5",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC6",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC7",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC8",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6EC9",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ECA",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ECB",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ECC",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ECD",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ECE",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ECF",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ED0",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ED1",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ED2",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ED3",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 7"
  },
  {
    "Address": "6ED4",
    "Function": "X Short Factor (EMA)   ///MODE 8",
    "Notes": "MODE 8"
  },
  {
    "Address": "6ED5",
    "Function": "X Long   Factor (EMA)",
    "Notes": "MODE 8"
  },
  {
    "Address": "6ED6",
    "Function": "X\u00a0Threshold   Byte 1",
    "Notes": "MODE 8"
  },
  {
    "Address": "6ED7",
    "Function": "X\u00a0Threshold Byte 2",
    "Notes": "MODE 8"
  },
  {
    "Address": "6ED8",
    "Function": "X Number of Patterns",
    "Notes": "MODE 8"
  },
  {
    "Address": "6ED9",
    "Function": "Z Short   EMA Factor (EMA)",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EDA",
    "Function": "Z Long   EMA Factor (EMA)",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EDB",
    "Function": "Z Threshold Byte 1",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EDC",
    "Function": "Z Threshold Byte 2",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EDD",
    "Function": "Z Number of Patterns",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EDE",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EDF",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE0",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE1",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE2",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE3",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE4",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE5",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE6",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE7",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE8",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EE9",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EEA",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EEB",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EEC",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EED",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EEE",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EEF",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "6EF0",
    "Function": "X & Z Pattern Start Offsets",
    "Notes": "MODE 8"
  },
  {
    "Address": "7000",
    "Function": "M1",
    "Notes": "Mode 1 Flash Pattern Data Start"
  },
  {
    "Address": "7080",
    "Function": "M2",
    "Notes": "Mode 2 Flash Pattern Data Start"
  },
  {
    "Address": "7100",
    "Function": "M3",
    "Notes": "Mode 3 Flash Pattern Data Start"
  },
  {
    "Address": "7180",
    "Function": "M4",
    "Notes": "Mode 4 Flash Pattern Data Start"
  },
  {
    "Address": "7200",
    "Function": "M5",
    "Notes": "Mode 3 Flash Pattern Data Start"
  },
  {
    "Address": "7280",
    "Function": "M6",
    "Notes": "Mode 4 Flash Pattern Data Start"
  },
  {
    "Address": "7300",
    "Function": "M7",
    "Notes": "Mode 3 Flash Pattern Data Start"
  },
  {
    "Address": "7380",
    "Function": "M8",
    "Notes": "Mode 4 Flash Pattern Data Start"
  },
  {
    "Address": "7400",
    "Function": "MAINLED_WORK_MODE",
    "Notes": "Store persistant light setting"
  },
  {
    "Address": "7401",
    "Function": "FlagChargeShipMode",
    "Notes": "1 = Shipping Mode Enabled; Output can't be turned on."
  },
  {
    "Address": "7402",
    "Function": "BatVolIndexBank",
    "Notes": "Store battery state of charge level"
  },
  {
    "Address": "7600",
    "Function": "Product_ID",
    "Notes": "Product ID Code"
  },
  {
    "Address": "7601",
    "Function": "SerNum1",
    "Notes": "4 byte serial number"
  },
  {
    "Address": "7602",
    "Function": "SerNum2",
    "Notes": ""
  },
  {
    "Address": "7603",
    "Function": "SerNum3",
    "Notes": ""
  },
  {
    "Address": "7604",
    "Function": "SerNum4",
    "Notes": ""
  },
  {
    "Address": "7605",
    "Function": "",
    "Notes": "METADATA_VERSION"
  },
  {
    "Address": "7606",
    "Function": "",
    "Notes": "FACTORY_ID"
  },
  {
    "Address": "7607",
    "Function": "",
    "Notes": "MANUFACTURE_YEAR"
  },
  {
    "Address": "7608",
    "Function": "",
    "Notes": "MANUFACTURE_MONTH"
  },
  {
    "Address": "",
    "Function": "\u2026",
    "Notes": ""
  },
  {
    "Address": "767E",
    "Function": "Private Key",
    "Notes": "2s Compliment of the chips UUID that is a check to stop application from exceuting"
  },
  {
    "Address": "767F",
    "Function": "Soft Lock",
    "Notes": "Set to 0 to protect the manufacturing data block and memory read"
  },
  {
    "Address": "7680",
    "Function": "USB Name",
    "Notes": "(USB Device Name)"
  },
  {
    "Address": "7681",
    "Function": "USB Name",
    "Notes": "2"
  },
  {
    "Address": "7682",
    "Function": "USB Name",
    "Notes": "3"
  },
  {
    "Address": "7683",
    "Function": "USB Name",
    "Notes": "4"
  },
  {
    "Address": "7684",
    "Function": "USB Name",
    "Notes": "5"
  },
  {
    "Address": "7685",
    "Function": "USB Name",
    "Notes": "6"
  },
  {
    "Address": "7686",
    "Function": "USB Name",
    "Notes": "7"
  },
  {
    "Address": "7687",
    "Function": "USB Name",
    "Notes": "8"
  },
  {
    "Address": "7688",
    "Function": "USB Name",
    "Notes": "9"
  },
  {
    "Address": "7689",
    "Function": "USB Name",
    "Notes": "10"
  },
  {
    "Address": "768A",
    "Function": "USB Name",
    "Notes": "11"
  },
  {
    "Address": "",
    "Function": "\u2026",
    "Notes": ""
  },
  {
    "Address": "",
    "Function": "USB Name",
    "Notes": "23"
  },
  {
    "Address": "",
    "Function": "\u2026",
    "Notes": ""
  },
  {
    "Address": "77FF",
    "Function": "",
    "Notes": "Security byte"
  }
]